import ULThemeSeparator from "@/components/ULThemeSeparator";
import { applyAuth0Theme } from "@/utils/theme";

import MFAEmailListHeader from "./components/MFAEmailListHeader";
import MFAEmailListOptions from "./components/MFAEmailListOptions";
import { useMfaEmailListManager } from "./hooks/useMFAEmailListManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MFAEmailList() {
    // Extracting attributes from hook made out of MFAEmailListInstance class of Auth0 React SDK
    const { mfaEmailList, texts, locales } = useMfaEmailListManager();

    // Apply theme from SDK instance when screen loads
    applyAuth0Theme(mfaEmailList);
    return (
        // Applying UDS theme overrides using the "theme-universal" class
        <AuthLayout title={texts?.pageTitle || locales.pageTitle}>

            <MFAEmailListHeader />
            <ULThemeSeparator className="grow-0" />
            <MFAEmailListOptions />

        </AuthLayout>
    );
}

export default MFAEmailList;
